import { useTranslation } from 'react-i18next';
import React, { useState, useContext, useEffect, useRef } from 'react';
import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications';
import { useLocation } from "react-router-dom";
// * CSS
// * Helpers
import API, { AMS } from "../../services/api";
import AuthContext from '../../context/Auth/AuthContext';
// External dependencies
import { RangeStepInput } from 'react-range-step-input';

const GraphSelectors = (props) => {
    /**We use the useTranslation hook to update the text when the language changes */
    const { t } = useTranslation('common');
    //* To can acess the parameters sent via history.push
    const location = useLocation();
    // Session context to get the current institution data
    const { user } = useContext(AuthContext);
    // State variables
    
    const [benefitSelector, setBenefitSelector] = useState(0);
    const [groupSelector, setGroupSelector] = useState(0);
    const [sexSelector, setSexSelector] = useState(0);
    const [yearSelector, setYearSelector] = useState(0);
    const [tCompleteSelector, setTCompleteSelector] = useState(0)
    const [year, setYear] = useState(0);
    const [yearTComplete, setYearTComplete] = useState(0);
    const [change, setChange] = useState(false); 
    const [sexBothSelector, setSexBothSelector] = useState(2);
    const [gdpgexSelector, setGdpgexSelector] = useState(0);

    // to control first render
    const ref = useRef(true);

    // this useEffect is executed each time the selectedNodeData variable is updated in the graphControl component
    useEffect(() => {
        //Restore selectors values when tree view change
        if (props.selectedNodeData) {
            /*
            setSexSelector(0);
            setGroupSelector(0);
            setYearSelector(0);
            setBenefitSelector(0);
            setTCompleteSelector(0);
            */
            setSexBothSelector(2);
            setGdpgexSelector(0);
        }
    }, [props.selectedNodeData]);

    // this useEffect is executed each time the graphMetadata variable is updated in the graphView component
    useEffect(() => {
        //Restore selectors values when tree view change
        if (props.graphMetadata) {
            props.graphMetadata.dimdata.forEach((item) => {
                if (item.code === "t") {
                    setYear(item.minVal)
                }
                if (item.code === "t_complete") {
                    setYearTComplete(item.minVal)
                }
            })
        }
    }, [props.graphMetadata]);

    const generateSelectors = () => {
        // * we use breadcumb from selectedNode and metada information, to generate selectors
        // * only suppoty combobox for sex and group
        try {
            if (props.selectedNodeData.type === 'graph') {
                if (props.selectedNodeData.breadcrumb !== "") {
                    if (props.graphMetadata) {

                        const selectorList = props.selectedNodeData.breadcrumb.split(',');

                        let result = [];

                        // Iterates the selector´s list
                        for (let i = 0; i < selectorList.length; i++) {
                            const selector = selectorList[i];

                            const dimindex = props.graphMetadata.dimlist.indexOf(selector);
                            // Gets the list of values according to current dimension (dimindex)
                            const options = props.graphMetadata.dimdata[dimindex].values.map((op, j) => {
                                return <option key={op} value={j}>{toCapital(op)}</option>
                            });

                            // If the current graph has the another sex dimension (with "both")
                            if (selector === "sboth") {
                                result.push(
                                    <select key={selector} className="form-control ilo-input ilo-selectors" value={sexBothSelector} onChange={(e) => { setSexBothSelector(e.target.value) }}>
                                        {options.reverse()}
                                    </select>
                                )
                            }

                            //  If the current graph has the gaps dimension
                            if (selector === "gdpgex") {
                                result.push(
                                    <select key={selector} className="form-control ilo-input ilo-selectors" value={gdpgexSelector} onChange={(e) => { setGdpgexSelector(e.target.value) }}>
                                        {options}
                                    </select>
                                )
                            }

                            /*

                            // If the current graph has benefits
                            if (selector === "b") {
                                result.push(
                                    <select className="form-control ilo-input ilo-selectors" value={benefitSelector} onChange={(e) => { setBenefitSelector(e.target.value) }}>
                                        {options}
                                    </select>
                                )
                            }

                            // If the current graph has groups
                            if (selector === "g") {
                                result.push(
                                    <select className="form-control ilo-input ilo-selectors" value={groupSelector} onChange={(e) => { setGroupSelector(e.target.value) }}>
                                        {options}
                                    </select>
                                )
                            }

                            // If the current graph has sex
                            if (selector === "s") {
                                result.push(
                                    <select className="form-control ilo-input ilo-selectors" value={sexSelector} onChange={(e) => { setSexSelector(e.target.value) }}>
                                        {options}
                                    </select>
                                )
                            }

                            // If the current graph has time
                            if (selector === "t") {
                                result.push(
                                    <>
                                        <RangeStepInput
                                            className="form-control ilo-input ilo-selectors-slider"
                                            min={props.graphMetadata.dimdata[dimindex].minVal}
                                            max={props.graphMetadata.dimdata[dimindex].maxVal}
                                            value={year}
                                            step={1}
                                            onChange={onChangeYearSlider}
                                            disabled={change}
                                        /> <p className="yearSelector">{year}</p>
                                    </>
                                )
                            }

                            // If the current graph has t_complete
                            if (selector === "t_complete") {
                                result.push(
                                    <>
                                        <RangeStepInput
                                            className="form-control ilo-input ilo-selectors-slider"
                                            min={props.graphMetadata.dimdata[dimindex].minVal}
                                            max={props.graphMetadata.dimdata[dimindex].maxVal}
                                            value={yearTComplete}
                                            step={1}
                                            onChange={onChangeYearCompleteSlider}
                                            disabled={change}
                                        /> <p className="yearSelector">{yearTComplete}</p>
                                    </>
                                )
                            }

                            */

                        }

                        return result;
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
        return null;
    }

    useEffect(() => {
        if (props.showGraph) {
            setChange(false);
        }
    }, [props.showGraph]);

    useEffect(() => {
        // * To avoid duplicate call to getGraph function in the first render
        if (ref.current) {
            ref.current = false;
        } else {
            // * this useEffect handle the change from the selectors and get update the matrix using the new selectors
            if (props.selectedNodeData.type === 'graph') {
                props.setShowGraph(false);
                const selectorList = props.selectedNodeData.breadcrumb.split(',');
                const selectors = selectorList.map((item) => {


                    if (item === "sboth") {
                        return `sboth=${sexBothSelector}`;
                    }
                    if (item === "gdpgex") {
                        return `gdpgex=${gdpgexSelector}`;
                    }

                    /*
                    if (item === "b") {
                        return `b=${benefitSelector}`;
                    }
                    if (item === "g") {
                        return `g=${groupSelector}`;
                    }
                    if (item === "s") {
                        return `s=${sexSelector}`;
                    }
                    if (item === "t") {
                        return `t=${yearSelector}`;
                    }
                    if (item === "t_complete") {
                        return `t_complete=${tCompleteSelector}`;
                    }
                    */

                });
                props.getGraph(props.selectedNodeData.code, selectors.join(','));
            }
        }


    }, [sexBothSelector, gdpgexSelector, /*sexSelector, groupSelector, benefitSelector, yearSelector, tCompleteSelector*/]);// eslint-disable-line react-hooks/exhaustive-deps

    // Converts the first letter of string in capital letter
    const toCapital = (param) => {
        // First letter in capital letter
        const capLetter = param.charAt(0).toUpperCase();
        // Rest of the word without the first letter
        const restWord = param.slice(1);
        // result
        const result = `${capLetter}${restWord}`;
        return result;
    };

    /*
    const onChangeYearSlider = (e) => {

        setYear(Number(e.target.value));
        // setChange(true);

        let index = 0;
        props.graphMetadata.dimdata.forEach((item) => {
            if (item.code === "t") {
                index = item.values.indexOf(Number(e.target.value));
            }
        });
        setYearSelector(index);
    }

    const onChangeYearCompleteSlider = (e) => {
        setYearTComplete(Number(e.target.value));

        let index = 0;
        props.graphMetadata.dimdata.forEach((item) => {
            if (item.code === "t_complete") {
                index = item.values.indexOf(Number(e.target.value));
            }
        });
        setTCompleteSelector(index);
    }
    */

    return (
        props.selectedNodeData !== null ?
            <div className="container-fluid">
                <div className="row mt-2">
                    <div className="col-12">
                        <h4>{props.selectedNodeData.text}</h4>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-12">
                        <p>{t(props.selectedNodeData.desc)}</p>
                    </div>
                </div>
                <div className="row mx-0 my-3">
                    {generateSelectors()}
                </div>
            </div> : null
    );
}

export default GraphSelectors